import { SWRConfiguration } from 'swr';

import { RelationshipType, getMgrEmpRelationship } from '~/data/search/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

const SWR_KEY_GET_RELATIONSHIP_TYPE = 'useGetRelationshipType';

type PropsType = {
  employeeId?: number;
  targetId?: number;
};

export const useGetManagerEmployeeRelationshipType = (
  props: PropsType,
  swrConfig?: SWRConfiguration<RelationshipType>,
): UseSWROutput<RelationshipType> => {
  const { employeeId, targetId } = props;

  const defaultConfig = {
    revalidateOnFocus: false,
    refreshInterval: 0,
  };

  return useSWR(
    !!employeeId && !!targetId
      ? [SWR_KEY_GET_RELATIONSHIP_TYPE, employeeId, targetId]
      : null,
    ([key_, employeeId, targetId]) =>
      getMgrEmpRelationship(employeeId, targetId),
    {
      ...defaultConfig,
      ...swrConfig,
    },
  );
};
